import React from 'react';

import { Title } from '@mantine/core';

import VisitList from '../components/visit/VisitList';

const ViewVisits: React.FC = () => {
  return (
    <>
      <Title mb="xl" order={1}>Visits</Title>
      
      <VisitList title="All Visits" />
    </>
  );
};

export default ViewVisits;

